module.exports = __webpack_public_path__ + "img/kate_macK210689.f47a087c.jpg";